module.exports = __webpack_public_path__ + "img/horizontal_3_2_r_pp2_1.2e6a5948.png";